import { Widget } from "blue-widgets";

class CopyText extends Widget {
  constructor(el) {
    super(el);
    this.createPopup = this.createPopup.bind(this);
    this.init();
  }

  init() {
    this.el.addEventListener("click", this.copyHandler.bind(this), false);
    this.createPopup();
  }

  createPopup() {
    this.popup = document.createElement("span");
    this.popup.style.display = "none";
    this.popup.className = "popup";
    this.popup.textContent = this.options.feedback;
    this.popup.setAttribute("role", "status");
    this.popup.setAttribute("aria-live", "polite");
    this.el.appendChild(this.popup);
  }

  showPopup() {
    this.popup.style.display = "block";
    this.popup.setAttribute("aria-atomic", "true");
    this.popup.focus();
    this.el.style.position = this.options.position || "relative";
    this.el.style.overflow = "visible";

    setTimeout(() => {
      this.hidePopup();
    }, 2000);
  }

  hidePopup() {
    this.popup.style.display = "none";
    this.popup.removeAttribute("aria-live");
    this.el.focus();
  }

  copyHandler() {
    navigator.clipboard.writeText(this.options.value);
    this.showPopup();
  }

  beforeRemove() {
    this.el.removeEventListener("click", this.copyHandler);
  }
}

export default CopyText;
